module.exports = __webpack_public_path__ + "img/atencion.6b45b52c.jpg";